import {
  Component,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Widget } from 'src/app/core/models/core.models';
import { UtilsService } from 'src/app/core/services/utils.service';
import { SuiButtonComponent } from '@sui/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-widget-settings-debug-chart-json',
  templateUrl: './widget-settings-debug-chart-json.component.html',
  styleUrls: ['./widget-settings-debug-chart-json.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SuiButtonComponent, TranslatePipe],
})
export class WidgetSettingsDebugChartJsonComponent {
  @Input() widget: Widget;

  prettyObject = '';

  protected utilService = inject(UtilsService);

  ngOnInit() {}

  copyText(textElement: HTMLPreElement) {
    const text = textElement.innerText;
    this.utilService.copyToClipboard(text);
  }
}
